import { useState, useEffect } from 'react'
import api from '../../services/api'
import toast from 'react-hot-toast'

export default function Equipo() {
  const [usuarios, setUsuarios] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [editando, setEditando] = useState(null)
  const [form, setForm] = useState({ nombre: '', email: '', password: '', rol: 'agente', telefono: '' })

  const cargar = async () => { const { data } = await api.get('/usuarios'); setUsuarios(data) }
  useEffect(() => { cargar() }, [])

  const guardar = async (e) => {
    e.preventDefault()
    try {
      if (editando) {
        const { password, ...rest } = form
        const body = password ? { ...rest, password } : rest
        await api.put(`/usuarios/${editando.id}`, body)
      } else {
        await api.post('/usuarios', form)
      }
      toast.success('Guardado')
      setShowModal(false); setEditando(null); setForm({ nombre: '', email: '', password: '', rol: 'agente', telefono: '' })
      cargar()
    } catch (e) { toast.error(e.response?.data?.error || 'Error') }
  }

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar usuario?')) return
    await api.delete(`/usuarios/${id}`); cargar()
  }

  const editar = (u) => { setEditando(u); setForm({ ...u, password: '' }); setShowModal(true) }

  return (
    <div className="page">
      <div className="flex justify-between items-center" style={{ marginBottom: 18 }}>
        <div>
          <h1 className="text-2xl font-bold">🧑‍💼 Equipo</h1>
          <p className="text-muted">Administra los miembros de tu equipo</p>
        </div>
        <button className="btn btn-primary" onClick={() => { setEditando(null); setForm({ nombre: '', email: '', password: '', rol: 'agente', telefono: '' }); setShowModal(true) }}>+ Agregar</button>
      </div>

      <div className="card" style={{ padding: 0 }}>
        <table className="table table-card">
          <thead><tr><th>Nombre</th><th>Email</th><th>Rol</th><th>Estado</th><th>Último login</th><th></th></tr></thead>
          <tbody>
            {usuarios.map(u => (
              <tr key={u.id}>
                <td data-label="Nombre">
                  <div className="flex items-center gap-2">
                    <div className="avatar avatar-sm">{(u.nombre || '?')[0].toUpperCase()}</div>
                    {u.nombre}
                  </div>
                </td>
                <td data-label="Email">{u.email}</td>
                <td data-label="Rol"><span className="badge badge-primary">{u.rol}</span></td>
                <td data-label="Estado">
                  <span className={`status-dot status-${u.estadoOnline === 'disponible' ? 'conectado' : 'desconectado'}`} />
                  {' '}{u.estadoOnline}
                </td>
                <td data-label="Último login">{u.ultimoLogin ? new Date(u.ultimoLogin).toLocaleDateString() : 'Nunca'}</td>
                <td>
                  <button className="btn btn-sm btn-ghost" onClick={() => editar(u)}>✏️</button>
                  <button className="btn btn-sm btn-ghost" onClick={() => eliminar(u.id)}>🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">{editando ? 'Editar' : 'Nuevo'} miembro</span>
              <button className="btn btn-ghost btn-icon" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <form onSubmit={guardar}>
              <div className="modal-body">
                <div className="form-group"><label className="form-label">Nombre</label><input className="input" required value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} /></div>
                <div className="form-group"><label className="form-label">Email</label><input className="input" type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} /></div>
                <div className="form-group">
                  <label className="form-label">{editando ? 'Nueva contraseña (dejar vacío para no cambiar)' : 'Contraseña'}</label>
                  <input className="input" type="password" required={!editando} value={form.password} onChange={e => setForm({...form, password: e.target.value})} />
                </div>
                <div className="form-group">
                  <label className="form-label">Rol</label>
                  <select className="select" value={form.rol} onChange={e => setForm({...form, rol: e.target.value})}>
                    <option value="agente">Agente (solo sus chats)</option>
                    <option value="supervisor">Supervisor (ve todo, no config)</option>
                    <option value="admin">Admin (control total)</option>
                  </select>
                </div>
                <div className="form-group"><label className="form-label">Teléfono</label><input className="input" value={form.telefono || ''} onChange={e => setForm({...form, telefono: e.target.value})} /></div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn" onClick={() => setShowModal(false)}>Cancelar</button>
                <button className="btn btn-primary">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
